export enum CapacityType {
  'Firm' = 'Firm',
  'Interruptible' = 'Interruptible',
}
